export const ACTIVATE_ACCOUNT_MODAL = 'activate-account-modal';
const activateAccountModal = () => ({ type: ACTIVATE_ACCOUNT_MODAL });
export default activateAccountModal;
